import { render, staticRenderFns } from "./ManagePropertiesView.vue?vue&type=template&id=0d99f4ea&scoped=true&lang=pug&"
import script from "./ManagePropertiesView.vue?vue&type=script&lang=ts&"
export * from "./ManagePropertiesView.vue?vue&type=script&lang=ts&"
import style0 from "./ManagePropertiesView.vue?vue&type=style&index=0&id=0d99f4ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d99f4ea",
  null
  
)

export default component.exports